__turbopack_context__.v({
  "contact": "bUcRcq_contact",
  "container": "bUcRcq_container",
  "content": "bUcRcq_content",
  "image": "bUcRcq_image",
  "innerImage": "bUcRcq_innerImage",
  "mobileTitle": "bUcRcq_mobileTitle",
  "text": "bUcRcq_text",
});
